import React from 'react';
import AJAX_loading from '../../assets/icons/AJAX_loading.gif';

export const BaklaagLoader = () => {
  return <img src={AJAX_loading} />;
};
